import { DateTime } from 'luxon';
import { isWeekday } from '@sg/utils/src';

export function isLondonWorkingHours(): boolean {
  const londonTime = DateTime.local().setZone('UTC+1');
  return isWeekday(londonTime) && londonTime.hour >= 8 && londonTime.hour < 19;
}
